module.exports = __webpack_public_path__ + "img/pecans-bg-portrait-320w.e39c5131.jpg";